<template>
  <transition-group name="list" appear>
    <div v-for="member in progressSorted" :key=member.member>
      <div id='member-section'>
        <div class="member">{{ member.member }}</div>
        <div>
          <img v-bind:class="[{pinned: (settings.work.pin === member.member)},{unpinned: (settings.work.pin !== member.member)}]" class="star" v-on:click="updatePin(member.member)" src="../../assets/star-blue-24px.svg">
          <img v-if="settings.work.queue" v-bind:class="[{filtered: (settings.work.filter === member.member)},{unfiltered: (settings.work.filter !== member.member)}]" class="filter" v-on:click="updateFilter(member.member)" src="../../assets/filter_list_blue_24dp.svg">
        </div>
      </div>
      <div class="queue">
        <div v-for="card in member.cards" :key=card.id>
          <a v-bind:href="card.link" target="_blank">
            <div class="card card-progress" v-bind:class="[ {neutral: (defaultZero(card.progress_days) < oldThreshold && defaultZero(card.progress_days) > newThreshold)}, {new: (defaultZero(card.progress_days) <= newThreshold)}, {old: (defaultZero(card.progress_days) >= oldThreshold)} ]">
              <div class="card-title">{{ card.contract }}</div>
              <span class="card-name">{{ shortName(card.name) }}</span>
              <span class="timestamp-progress">{{ formatTimestamp(card.progress_first_seen, 'month') }}</span>
              <div v-if="settings.global.dots" class="days">
                <div v-for="(n,i) in dots(defaultZero(card.progress_days))" v-bind:key=i>
                  <div v-html=n></div>
                </div>
              </div>
              <div v-else class="days">
                {{ defaultZero(card.progress_days) }}
              </div>
              <div v-if="settings.work.icons" class="icon">
                <img class="icon-img" v-if="card.platform == 'trello'" src="../../assets/trello-icon.png">
                <img class="icon-img" v-if="card.platform == 'zendesk'" src="../../assets/zendesk-icon.png">
                <img class="icon-img" v-if="card.platform == 'jira'" src="../../assets/jira-icon.png">
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'

export default {
  name: 'WorkList',
  props: [
    'progressSorted',
    'oldThreshold',
    'newThreshold'
  ],
  computed: {
    ...mapGetters([
      'id_token',
      'accounts',
      'settings'
    ])
  },
  methods: {
    checkMove: function (evt) {
      const newIndex = evt.moved.newIndex
      const oldIndex = evt.moved.oldIndex
      const card = evt.moved.element

      var cardAbove = null
      var cardBelow = null
      var newPriority = null

      if (newIndex === 0) {
        cardBelow = this.planned[newIndex + 1]
        newPriority = cardBelow.priority - 1
      } else if (newIndex === this.planned.length - 1) {
        cardAbove = this.planned[newIndex - 1]
        newPriority = cardAbove.priority + 1
      } else {
        cardAbove = this.planned[newIndex - 1]
        cardBelow = this.planned[newIndex + 1]
        if (cardAbove.priority === cardBelow.priority) {
          newPriority = newIndex > oldIndex ? cardAbove.priority + 1 : cardBelow.priority - 1
        } else {
          newPriority = Math.random() * (cardAbove.priority - cardBelow.priority) + cardBelow.priority
        }
      }

      this.priority(card.id, newPriority)

      return true
    },
    toBottom: function (cardId) {
      var newPriority = this.planned[this.planned.length - 1].priority + 1
      this.priority(cardId, newPriority)
    },
    toTop: function (cardId) {
      var newPriority = this.planned[0].priority - 1
      this.priority(cardId, newPriority)
    },
    showCard: function (platform) {
      return this.settings.work[platform]
    },
    updatePin: function (member) {
      if (this.settings.work.pin !== member) {
        this.$store.dispatch('UPDATE_SETTINGS', { namespace: 'work', key: 'pin', value: member })
      } else {
        this.$store.dispatch('RESET_SETTINGS', { namespace: 'work', key: 'pin' })
      }
    },
    updateFilter: function (member) {
      if (this.settings.work.filter !== member) {
        this.$store.dispatch('UPDATE_SETTINGS', { namespace: 'work', key: 'filter', value: member })
      } else {
        this.$store.dispatch('RESET_SETTINGS', { namespace: 'work', key: 'filter' })
      }
    },
    formatTimestamp: function (timestamp, period) {
      let date = new Date(timestamp * 1000)
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Octr', 'Nov', 'Dec']
      let weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      let day = date.getDate()
      let weekday = weekdays[date.getDay()]
      let month = months[date.getMonth()]
      let hours = date.getHours()
      let minutes = '0' + date.getMinutes()
      if (period === 'week') {
        return weekday + ' ' + hours + ':' + minutes.substr(-2)
      } else {
        return month + ' ' + day + ', ' + hours + ':' + minutes.substr(-2)
      }
    },
    formatTime: function (time) {
      if (time > 0) {
        let seconds = time
        let minutes = Math.floor(seconds / 60)
        let hours = Math.floor(minutes / 60)
        if (hours > 0) {
          return hours + 'h'
        } else if (minutes > 0) {
          return minutes + 'm'
        } else {
          return seconds + 's'
        }
      } else {
        return ''
      }
    },
    defaultZero: function (value) {
      if (value) {
        return value
      } else {
        return 0
      }
    },
    shortName: function (name) {
      if (name.length > 120) {
        return name.substr(0, 120) + '...'
      } else {
        return name
      }
    },
    dots: function (days) {
      let output = []
      if (days >= 40) {
        output.push(...Array(1).fill('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="#f070a1"/><title>' + days + '</title></svg>'))
      } else if (days >= 5) {
        let dots = Math.floor(days / 5)
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#f070a1"><title>' + days + '</title></circle></svg>'))
      } else {
        let dots = days
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#77a6f7"><title>' + days + '</title></circle></svg>'))
      }
      return output
    },
    priority: function (cardId, priority) {
      HTTP.put(`/cards/priority/${cardId}`, {priority: priority})
        .then(() => {
          this.getWork()
        })
        .catch(function (error) {
          this.flashMessage.error({
            message: `Failed to alter card priority : ${error.message}`
          })
        })
    },
    getWork: function () {
      HTTP.get('/cards/work')
        .then((response) => {
          this.planned = response.data.planned
          this.progress = response.data.progress
        })
        .catch(function (error) {
          this.flashMessage.error({
            message: `Failed to alter card priority : ${error.message}`
          })
        })
    }
  }
}
</script>

<style scoped src='../../assets/stylesheet/Work.css'></style>



// WEBPACK FOOTER //
// src/components/Work/WorkList.vue